import { useState } from "react";
import server from "../../api/server";
import cookie from "js-cookie";
import { handleImage } from "../../helpers/data/navbar";

const ImageUpdate = ({ item, sliders, setSliders, index }) => {
	const [selectedImage, setSelectedImage] = useState({
		preview: null,
		path: "",
	});

	const imageChange = async e => {
		if (e.target.files && e.target.files.length > 0) {
			const formData = new FormData();
			formData.append("file", e.target.files[0]);

			const { data } = await server(cookie).post("/upload", formData);
			const path = data?.data?.file?.path;
			setSelectedImage({
				preview: e.target.files[0],
				path,
			});

			const newSections = sliders.map((section, sliderIndex) => {
				if (sliderIndex !== index) return section;
				return {
					...section,
					image: `${path}`,
				};
			});

			setSliders(() => newSections);

			e.target.value = null;
		}
	};

	const removeSelectedImage = e => {
		e.preventDefault();

		setSelectedImage("");
		const newSections = sliders.map((section, sliderIndex) => {
			if (index !== sliderIndex) return section;
			return {
				...section,
				image: ``,
			};
		});

		setSliders(() => newSections);
	};

	return (
		<div className="form-group required">
			<h5>
				{/* <FormattedMessage id="mainImage" /> */}
				ارفع صورة
			</h5>

			<div className="image-uploader image-contain">
				<label>
					{(selectedImage.preview || item?.image) && (
						<div>
							<img
								src={
									selectedImage && selectedImage.preview
										? URL.createObjectURL(selectedImage.preview)
										: handleImage(item?.image)
								}
								style={{ objectFit: "contain" }}
								width={160}
								height={160}
								alt=""
							/>
							<button className="removeImg" onClick={removeSelectedImage}>
								{/* <img src={removeImg} alt="" /> */}X
							</button>
						</div>
					)}
					<input accept="image/*" type="file" onChange={imageChange} />
				</label>
			</div>
		</div>
	);
};

export default ImageUpdate;
